import React from 'react';
import ClueFragments from './components/ClueFragments';
import SolutionInput from './components/SolutionInput';
import Keyboard from './components/Keyboard';
import { handleInput, onReveal, saveTriword } from './triwordUtils';
import PuzzleTopBar from '../shared/PuzzleTopBar';
import { PuzzleNames } from '../../../utils/types';
import { TriwordStore } from './TriwordStore';
import Instructions from './components/Instructions';
import { useAmplitudeTracking, useFirstTimeInstructions, useKeyboardInput, usePageVisibilityPause, useStructuredDataEmbedding, useWindowHeightStyle } from '../shared/utils';
import PauseCover from '../shared/PauseCover';
import { isMobile } from 'react-device-detect';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';
import './Triword.less';

const Triword = () => {
  const { solved, revealed } = TriwordStore.useState();

  const pageHeight = useWindowHeightStyle();
  const containerHeight = isMobile ? pageHeight : undefined;

  usePageVisibilityPause(TriwordStore as any, saveTriword);
  useFirstTimeInstructions(PuzzleNames.Triword, TriwordStore as any);
  useKeyboardInput(handleInput, solved, revealed);
  useStructuredDataEmbedding(PuzzleNames.Triword);
  useAmplitudeTracking(PuzzleNames.Triword);
  usePuzzleTracking(PuzzleNames.Triword);

  return (
    <>
      <PuzzleTopBar
        puzzleName={PuzzleNames.Triword}
        store={TriwordStore as any}
        onReveal={onReveal}
        onSave={saveTriword}
        InstructionsComponent={Instructions}
      />
      <div className={`puzzleContainer triwordContainer ${isMobile ? 'mobile' : ''}`}
      style={{ height: containerHeight }}
      >
        <ClueFragments/>

        <div className="solutionInputContainer">
          <SolutionInput/>
        </div>
        {revealed &&
          <div className="outcomeBanner">
            Solution revealed. Try again tomorrow!
          </div>
        }

        <Keyboard/>
        <PauseCover store={TriwordStore as any}/>
      </div>
    </>
  );
};

export default Triword;